import { Fragment, useContext, useState } from "react";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import OfcList from "./OfcList";
import { useNavigate } from "react-router-dom";

const OfcListWrapper = () => {
    
    // HOOKS

    const [isOpenImport, setIsOpenImport] = useState(false);
    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de OFC' },
        { name: 'OFC', href: '/ofc' },
    ];

    const defaultFilters = {
        status: null,
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters}>
                <PageHeader title="Gestión de OFC" breadcrumb={breadCrumb}>
                    {userCan('create', 'census') && (
                        <div className="flex flex-col md:flex-row gap-2">
                            {/*
                            <Button
                                color="primary"
                                onClick={() => { setIsOpenImport(true); }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Importar OFC
                            </Button>
                            */}
                            <Button
                                color="primary"
                                onClick={() => { navigate('/ofc/create') }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear OFC
                            </Button>
                        </div>
                    )}
                </PageHeader>
                <OfcList
                    isOpenImport={isOpenImport}
                    setIsOpenImport={setIsOpenImport}
                />
            </FiltersProvider>
        </Fragment>
    )

}

export default OfcListWrapper;
